<template>
  <div class="honour">
    <div class="handbox">
      <van-row>
        <van-col span="8">
          <img class="honourpic" :src="img.honour">
        </van-col>
        <van-col span="16">
          <div class="progressbox">
            <div class="myprogress" :style="{'width':progress}"></div>
          </div>
          <div class="f-12 mt-5">50/100</div>
          <div class="f-16 f-w mt-10">业余车手</div>
        </van-col>
      </van-row>
    </div>
    <div class="state">
      <div class="f-16 f-w">荣耀说明：</div>
      <div class="f-12 mt-10">
        1、享有此荣耀的车主，可以优先获得活动
      </div>
      <div class="f-12">
        2、这一条规则说明什么什么说明什么说明一下
      </div>
      <div class="f-12">
        3、这一条规则说明什么什么说明什么说明一下
      </div>
      <div class="f-12">
        4、这一条规则说明什么什么说明什么说明一下
      </div>
    </div>
  </div>
</template>
<script>
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import { Row, Col } from 'vant';
  export default {
    data () {
      return {
        progress:"50%",
        img:{
          honour: require('../../../assets/img/lexus/my/honour.png'),
          honour_have: require('../../../assets/img/lexus/my/honour_have.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      var params={
        event_code: '我的荣耀',
        event_id: '',
        title: '',
        value: '',
        path: '/Lexus/My/HonourInfo.vue',
        user_id: this.user ? this.user.id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {

    },
    components: {
      [Row.name]: Row,
      [Col.name]: Col
    }
  }
</script>

<style lang="scss">
.honour{
  .handbox{
    width: 100%;
    height: 180px;
    background-color: #F8F8F8;
    .honourpic{
      width: 92px;
      height: 106px;
      padding: 35px;
    }
    .van-col--16{
      padding: 60px 30px;
      .mt-5{
        margin-top: 5px;
      }
    }
    .progressbox{
      width: 100%;
      height: 10px;
      background-color: #fff;
      border:1px solid #fff;
      .myprogress{
        height: 10px;
        background-color: #605C6B;
      }
    }
  }
  .state{
    line-height: 2;
    padding: 20px;
  }
  .mt-10{
    margin-top: 10px;
  }
}
</style>
